/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ICellEditorParams} from 'ag-grid-community';

export function commitValueToRow(params: ICellEditorParams | null, value: any): void {
    const colField = params?.colDef?.field;
    if (!colField || !params?.node || typeof params.node.setDataValue !== 'function') {
        return;
    }
    const parsedValue = typeof params.parseValue === 'function' ? params.parseValue(value) : value;
    params.node.setDataValue(colField, parsedValue);
}
